import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditMachine() {
  const { id } = useParams();

  const [WCs, setWCs] = useState([]);
  const [data, setData] = useState({
    workcenter_id: "",  // use same key as backend expects
    name: ""
  });

  useEffect(() => {
    fetchMachine();
    fetchWCs();
  }, []);

  const fetchMachine = () => {
    axios.get(baseUrl + "machines/" + id + "/")
      .then(res => {
        setData({
          workcenter_id: res.data.workcenter || "",
          name: res.data.name || ""
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Machine", "error"));
  };

  const fetchWCs = () => {
    axios.get(baseUrl + "workcenters/")
      .then(res => setWCs(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Work Centers", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.workcenter_id || !data.name) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("workcenter", data.workcenter_id);
    _formData.append("name", data.name);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "machines/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(response => {
        Swal.fire({
          title: "Machine Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
        setTimeout(() => window.location.href = '/machines/', 2000);
      })
      .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Machine</h4>

        {/* WorkCenter Dropdown */}
        <select
          name="workcenter_id"
          value={data.workcenter_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Work Center</option>
          {WCs.map((wc) => (
            <option key={wc.id} value={wc.id}>
              {wc.name}
            </option>
          ))}
        </select>

        {/* Machine Name */}
        <input
          type="text"
          className="form-control mt-3"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        {/* Submit */}
        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>
      </div>
    </div>
  );
}

export default EditMachine;
